<template>
  <div id="app">
    <router-view></router-view>
    <!-- <el-dialog
      title="全球货仓新版已上线"
      :visible.sync="dialogVisible"
      :width="width"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="app-guidance">
        <p>为了优化用户体验，全球货仓已经全面升级啦！</p>
        <p>界面更加美观，搜索更加简单明了，更人性化。</p>
        <p>快去体验新版吧~</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleLeaveFor">前 往</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      width: '30%'
    }
  },
  computed: {
    // guideDialog() {
    //   return this.$store.getters.guideDialog
    // }
    // dialogVisible: {
    //   get() {
    //     return this.guideDialog
    //   },
    //   set(newData) {
    //     this.$store.commit('SET_GUIDE_DIALOG', newData)
    //   }
    // }
  },
  methods: {
    // handleLeaveFor() {
    //   // window.open('https://zwy.zowoyoo.com')
    //   location.href = 'https://zwy.zowoyoo.com'
    // }
  },
  mounted() {
    const w = document.body.clientWidth
    if (w < 1024 && w >= 768) {
      this.width = '80%'
    }
    if (w < 768) {
      this.width = '80%'
    }
  }
}
</script>
<style lang="scss">
  @import url('./styles/reset.css');
  @import './styles/index.scss'; // 全局自定义的css样式
  @import url('./styles/home.css');
  @import url('./styles/flex.scss');
  #app {
    .app-guidance {
      p {
        padding: 10px 0;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/App.vue